import { render, staticRenderFns } from "./MyCenter.vue?vue&type=template&id=245757ac&scoped=true&"
import script from "./MyCenter.vue?vue&type=script&lang=js&"
export * from "./MyCenter.vue?vue&type=script&lang=js&"
import style0 from "./MyCenter.vue?vue&type=style&index=0&id=245757ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245757ac",
  null
  
)

export default component.exports